import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService { 

  // -- Base Url -- //
  api: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

  reqHeader = new HttpHeaders({
    // 'Content-Type' : 'multipart/form-data'
  });

  // --- Upload Profile And CNIC ---- //
  uploadProfileAndCnic(data: any) {
    return this.http.post(this.api+ '/UserAttachment', data, {headers: this.reqHeader});
  }

  // ----- Upload NTN ----- //
  uploadNtn(data: any) {
    return this.http.post(this.api+ '/Business/UploadFile', data);
  }

  // ---- User Attachment ---- //
  getUserAttachment(userId: any, attatchmentId: any) {
    return this.http.get( this.api+'/UserAttachment?UserId='+userId+'&AttachmentId='+attatchmentId);
  }

  // ---- Business Attachement ---- //
  getBusinessAttachment(businessId: any, attatchmentId: any) {
    return this.http.get( this.api+'/BusinessAttachment?BusinessId='+businessId+'&AttachmentId='+attatchmentId);
  }

  submitProfile(data: any) {
    return this.http.put(this.api+'/User/UpdateStatus', data);
  }
}
